import { FileAddOutlined } from "@ant-design/icons";
import { Alert, Card, Col, Form, Input, Row, Space } from "antd";
import { FormInstance } from "antd/lib/form";
import Dragger from "antd/lib/upload/Dragger";
import { omit } from "lodash";
import { useCallback } from "react";

import { ClassificationTransfer } from "./ClassificationTransfer";

type CodeFormType = {
  action: string;
  form: FormInstance<any>;
  handler: (values: any) => void;
  values: any;
  errors: string[];
};

const fields = [
  ["status", "status"],
  ["content", "content"],
  ["attachment", "attachment"],
];

export const onError = (form: any, setErrors: any) => ({ graphQLErrors }: any) => {
  const fieldsErrors: any[] = [];
  const errors: string[] = [];
  graphQLErrors.forEach((graphQLError: any) => {
    let found = false;
    fields.forEach(([fieldName, errorFieldName]) => {
      if (graphQLError.name === errorFieldName) {
        fieldsErrors.push({ name: fieldName, errors: (graphQLError as any).messages });
        found = true;
      }
    });
    if (!found) {
      errors.push(graphQLError.message);
    }
  });
  // console.log(fieldsErrors);
  // console.log(errors);
  form.setFields(fieldsErrors);
  setErrors(errors);
};

export const onFinish = (mutate: any, params: any, variables: any) => (values: any) => {
  const input = {
    ...omit(values, ["scheme", "candidacyClassifications"]),
    ...params,
    candidacyClassifications: values?.candidacyClassifications?.map((classificationId: string) => ({
      classificationId,
    })),
    attachment: values.attachment?.file ?? null,
  };

  mutate({ variables: { ...variables, input } });
};

export const CandidacyForm: React.FC<CodeFormType> = (props) => {
  const { action, form, handler, values, errors } = props;

  console.log(`Agencies/Collaborators/Abilities/Candidacies/CandidacyForm action: ${action}`);

  const valuesChangeHandler = useCallback(
    (changedValues, allValues) => {
      const fieldValues: any[] = [];
      if (changedValues.attachment && changedValues.attachment.file.status === "removed") {
        fieldValues.push({ name: ["attachment"], value: null });
      }
      form.setFields(fieldValues);
    },
    [form],
  );

  const initialValues = {
    ...omit(values, ["candidacyClassifications"]),
    attachment: values.attachment ? [{ url: values.attachment, name: "Download" }] : [],
  };

  const uploadProps: any = {
    maxCount: 1,
    accept: ".pdf, .doc, .xls, .xlsx",
    beforeUpload: () => {
      return false;
    },
  };

  return (
    <Card>
      {errors.length > 0 && (
        <Space direction="vertical" style={{ marginBottom: "10px" }}>
          {errors.map((error, index) => (
            <Alert key={index} type="error" message="Error" description={error} />
          ))}
        </Space>
      )}
      <Form
        layout="vertical"
        form={form}
        initialValues={initialValues}
        onValuesChange={valuesChangeHandler}
        onFinish={handler}
      >
        <Row gutter={[24, 0]}>
          <Col span={24}>
            <Form.Item name="content" label="Content" rules={[{ required: true, message: "is required" }]}>
              <Input.TextArea />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 0]}>
          <Col span={24}>
            <ClassificationTransfer
              scheme={values.scheme}
              candidacyClassifications={values.candidacyClassifications ?? []}
            />
          </Col>
        </Row>
        <Row gutter={[24, 0]}>
          <Col span={12}>
            <Form.Item name="attachment" label="Attachment" valuePropName={"defaultFileList"}>
              <Dragger {...uploadProps}>
                <FileAddOutlined />
                Click or drop here
              </Dragger>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
